import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instrumental',
  templateUrl: './instrumental.component.html',
  styleUrls: ['./instrumental.component.css']
})
export class InstrumentalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
